<div class="btn-wrap">
  <button
    pButton
    [label]="'ui.form_request.form_requests' | translate"
    class="p-button-fourth p-button-sm"
    (click)="showModal()"
  ></button>
</div>
<ng-container>
  <p-dialog
    [header]="'ui.form_request.form_requests' | translate"
    [(visible)]="modalActive"
    [modal]="true"
    [style]="{ width: '700px', 'min-height': '200px' }"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false"
  >
  <div class="wrapper">
    <div class="top-section">
      <div class="row title" [class.has-save-to-pms-column]="isAutomaticFormCompletionEnabled">
        <div class="cell">{{'ui.form_request.form' | translate}}</div>
        <div class="cell">{{'ui.form_request.sent' | translate}}</div>
        <div class="cell">{{'ui.form_request.status' | translate}}</div>
        <ng-container *ngIf="isAutomaticFormCompletionEnabled">
          <div class="cell synced-to-pms">{{'ui.form_request.saved_to_pms' | translate}}</div>
        </ng-container>
      </div>
      <ng-container *ngFor="let formSubmission of formSubmissions">
        <div class="row" [class.has-save-to-pms-column]="isAutomaticFormCompletionEnabled">
          <div class="cell">
            {{ formSubmission.form.name }}
          </div>

          <div class="cell">
            {{ formSubmission.createdAt | localizedDate:true }}
          </div>

          <div class="cell">
            <div class="capsule">
              <ng-container *ngIf="!formSubmission.completedAt">
                <div
                  class="cell bold"
                  [style.color]="
                    FormSubmissionStatus.PENDING | getFormSubmissionStatusColor
                  "
                >{{'ui.form_request.pending' | translate}}</div>
              </ng-container>
              <ng-container *ngIf="formSubmission.completedAt">
                <div
                  class="cell bold"
                  [style.color]="
                    FormSubmissionStatus.COMPLETED | getFormSubmissionStatusColor
                  "
                > {{'ui.form_request.complete' | translate}}</div>
              </ng-container>
            </div>
          </div>

          <div class="cell">
            <ng-container *ngIf="isAutomaticFormCompletionEnabled">
              <div class="synced-to-pms">
                <ng-container *ngIf="formSubmission?.form?.saveToPms">
                  <div class="not-saved-to-pms">
                    <ng-container *ngIf="formSubmission?.syncedToPms">
                      <i
                        class="pi pi-check-circle"
                        pTooltip="Saved to PMS"
                        tooltipStyleClass="success-tooltip"
                        tooltipPosition="top"
                      ></i>
                    </ng-container>
                    <ng-container *ngIf="!formSubmission?.syncedToPms" >
                        <img src="assets/images/icons/pending-submission.png"
                          height="22px"
                          alt="Pending submission to PMS"
                          [pTooltip]="'forms.components.submission_list_item.pending_form_completion' | translate"
                          tooltipStyleClass="tooltip-error"
                          tooltipPosition="top">
                    </ng-container>
                  </div>
                </ng-container>
                <ng-container *ngIf="!formSubmission?.form?.saveToPms">
                 {{'ui.form_request.na' | translate}}
                </ng-container>
              </div>
            </ng-container>
          </div>

        </div>
      </ng-container>
    </div>
    <div class="bottom-btn-row">
      <p-button
        [label]="'ui.form_request.view_all_form_request' |translate: {clientName: client?.fullName}"
        (click)="goToAllForms()"
      ></p-button>
    </div>
  </div>
  </p-dialog>
</ng-container>

